jQuery(document).ready(function ($) {
  $(".elc__proposte-di-lettura__slider").slick({
    dots: true,
    arrows: false,
  });
});
